import IconBase, { type IconProps } from '@yoweb/ui/components/Icon/IconBase';

export const QuestionHelpIcon = (props: IconProps) => (
  <IconBase {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75ZM2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12ZM13 16.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1-9.167a2.75 2.75 0 0 0-2.75 2.75.75.75 0 0 0 1.5 0 1.25 1.25 0 1 1 2.5 0c0 .406-.212.644-.658.945-.554.372-1.342 1.011-1.342 2.222v.25a.75.75 0 0 0 1.5 0V13c0-.423.222-.67.68-.977v-.001c.542-.365 1.32-.995 1.32-2.189A2.75 2.75 0 0 0 12 7.083Z"
      fill="currentColor"
    />
  </IconBase>
);

export default QuestionHelpIcon;
